// extracted by mini-css-extract-plugin
module.exports = {"chipWrapper":"FilterChip_chipWrapper__1DSWM","popoverDropdown":"FilterChip_popoverDropdown__gLwuS","closeButton":"FilterChip_closeButton___Aq1W"};